module.exports = __webpack_public_path__ + "2a2ff1ec076717671e616c282095a601.png";